import { render, staticRenderFns } from "./invoiceDigitConfigChildren.vue?vue&type=template&id=1753c4dd&scoped=true"
import script from "./invoiceDigitConfigChildren.vue?vue&type=script&lang=js"
export * from "./invoiceDigitConfigChildren.vue?vue&type=script&lang=js"
import style0 from "./invoiceDigitConfigChildren.vue?vue&type=style&index=0&id=1753c4dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1753c4dd",
  null
  
)

export default component.exports